import React from 'react';
import { Redirect, Link } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import utils from '../Utils';
import Pagination from './slider/Pagination';







import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import style from 'style/intro.css'

import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';
import { Button } from '@material-ui/core';

// const VirtualizeSwipeableViews = virtualize(SwipeableViews);


const STEP_TEST = 'test'
const STEP_RESULT = 'result'
class Intro extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      step: STEP_TEST,
      result: 0,
      redirectToLogin: false,
      sliderIndex: 0,
      answers: [],
      slides: [
        { t: 'سوال پزشکی دارید که نمی‌دونید از کی‌ بپرسید؟', d: 'اگر نمیدانید برای بیماریتان به چه پزشک یا متخصصی باید مراجعه کنید', img: '/images/slider/slider3.svg' },
        { t: 'نمی‌خواهید از خانه خارج شوید؟', d: 'اگر محدودیت زمانی برای مراجعه به پزشکی دارید و یا پزشک مورد نظرتان در مطب حضور ندارد یا در زمان شیوع بیماری ها (مثل کرونا) امکان مراجعه به درمانگاه یا مطب پزشک را ندارید', img: '/images/slider/slider2.svg' },
        { t: 'از بیماری‌تون خجالت می‌کشید!؟', d: 'اگر صحبت کردن راجع به مشکل‌تون براتون سخته یا برای پرسیدن سوالاتتان در مطب پزشک خجالت می کشید', img: '/images/slider/slider1.svg' },
      ]
    }
  }



  renderSlides = () => {
    return this.state.slides.map((slide, index) => {
      return (
        <div className='slide'>
          <img src={slide.img} alt='اسلاید' />
          <div className="title"> {slide.t}</div>
          <div className="desc"> {slide.d}</div>
        </div>
      )
    })
  }

  handleChangeIndex = index => {
    this.setState({ sliderIndex: index })
  }

  nextSlide = () => {
    if (this.state.sliderIndex == 2)
      return this.props.setIntroShow(true)
    this.setState({ sliderIndex: this.state.sliderIndex + 1 })
  }

  prevSlide = () => {
    if (this.state.sliderIndex == 0)
      return
    this.setState({ sliderIndex: this.state.sliderIndex - 1 })
  }

  resetState = () => {
    this.setState({
      step: STEP_TEST,
      result: 0,
      sliderIndex: 0,
      answers: [],
    })
  }

  render() {
    return (
      <div className="intro-root">

        <SwipeableViews slideStyle={{ height: '100%' }} containerStyle={{ height: '100%' }}
          className='slider-root' index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} axis="x-reverse"
          disabled={false}>
          {this.renderSlides()}
        </SwipeableViews>
        <div className='intro-footer'>
          <div className='prev-slide' onClick={this.prevSlide}>
            قبلی
                  <ChevronRightRoundedIcon />
          </div>
          <div className='slide-number'>
            <Pagination dots={3} index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} style={{ position: 'unset', }} />
          </div>
          <div className='next-slide' onClick={this.nextSlide}>
            بعدی
              <ChevronLeftRoundedIcon></ChevronLeftRoundedIcon>
          </div>
        </div>

      </div>
    )
  }

}

export default Intro